const VIDEO_EXT_RE = /\.(mp4|webm|ogv|ogg|mov|m4v|mkv|avi|m3u8|flv)(\?|#|$)/i

/** 是否是可以直接播放的视频地址 */
export function isVideoUrl(url) {
  if (!url) return false
  return VIDEO_EXT_RE.test(String(url).trim())
}

/**
 * 从 <a> 上解析视频地址。
 * - B 端编辑器插入的视频链接会带 title="faq-video" 标记；
 * - 手写的普通链接按扩展名兜底识别。
 * 返回空字符串表示不是视频链接。
 */
export function getVideoSrc(anchor) {
  if (!anchor || !anchor.getAttribute) return ''
  const href = (anchor.getAttribute('href') || '').trim()
  if (!href) return ''
  const marked =
    anchor.getAttribute('title') === 'faq-video' ||
    anchor.getAttribute('data-video') === '1'
  if (marked || isVideoUrl(href)) return href
  return ''
}

/**
 * 给渲染后的 HTML 中的视频链接打上 data-video="1" 标记，
 * 供样式（播放图标）和点击弹窗播放使用；其余内容原样返回。
 */
export function markVideoLinks(html) {
  return String(html || '').replace(/<a\b([^>]*)>/gi, (full, attrs) => {
    const href = (attrs.match(/href\s*=\s*"([^"]*)"/i) || [])[1] || ''
    const isVideo = isVideoUrl(href) || /title\s*=\s*"faq-video"/i.test(attrs)
    if (!isVideo || /data-video\s*=/i.test(attrs)) return full
    const title = /title\s*=/i.test(attrs) ? '' : ' title="点击播放视频"'
    return `<a${attrs} data-video="1"${title}>`
  })
}
